export default theme => ({
  root: {},
  tab:{
    [theme.breakpoints.down('sm')]: {
      fontSize:'10px !important',
      padding: 5
    }
  },
});
